import { Stack, Button, IconButton, Tooltip, TextField, Typography } from "@mui/material";
import { useContext, useState, useEffect, ChangeEvent,  useCallback } from "react";
import styled from 'styled-components';
import Table from '../custom/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { INV_INVENTORY_SHOWCASE, INV_AJUSTMENT_COLUMN, InventoryData, MyObject, TransactionDetail } from "../../Models/Inventory";
import Modal from '../Modals';
import useService from '../../hooks/useService';
import { InventoryContext } from "../../contexts/InventoryContext";
import { ShowSerialNumbers, ShowTranscationDetails } from "./InventoryShowcase";
import { AuthContext } from "../../contexts/AuthContext";
import { GridColDef, GridRowSelectionModel, GridRowParams, GridRenderCellParams } from '@mui/x-data-grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { InventoryAdjustmentParams } from "../../services/Inventory/types";
import { fetchInventory, inventoryAdjustment } from "../../services/Inventory";
import { NotificationContext } from "../../contexts/NotificationContext";
import { ADJUSTMENT_DIRECTION, ADJUSTMENT_TYPE, INVENTORY_TYPE } from "../../utils/constant";

const InventoryType: any = {
  1: 'Normal SKU',
  2: 'Cut Bar/Loose Items',
  3: 'Buffing dust',
  4: 'Scrap from barter/buyback',
  5: 'Jobwork Metal',
  6: 'GMS Metal',
  7: 'Non-Serialized SKU'
}

const Container = styled.div`
  width: 1200px !important;
`
const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  cursor: zoom-in;
  padding: 3px 0;
`
interface STOModalProps {
  onClose: () => any;
}

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const InventoryAdjustment = ({ onClose }: STOModalProps) => {
  const { user } = useContext(AuthContext)
  const { inventories } = useContext(InventoryContext)
  const { notify } = useContext(NotificationContext);
  const { execute } = useService()

  const [showSerialNumberModal, setShowSerialNumberModal] = useState<boolean | InventoryData>(false)
  const [showTranscationDetail, setShowTranscationDetail] = useState<boolean | TransactionDetail>(false)

  const [selectedSerialNumber, setselectedSerialNumber] = useState<number | null>();
  
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
  const [rows, setRows] = useState<InventoryData[]>([]);

  const reloadInventory = () => {
    execute(() => fetchInventory({ channelId: user.centerId! || '' }))
  }

  const closeTranscationDetailModal = () => {
    setShowTranscationDetail(false)
  }

  const closeSerialNumberModal = () => {
    setShowSerialNumberModal(false)
  }

  const SelectSerialNumberBox = ({serialNumbers}: {serialNumbers: number[]}) => {

    const handleChange = (event: SelectChangeEvent<typeof selectedSerialNumber>) => {
      const { target: { value } } = event
      setselectedSerialNumber(value as number)
    }

    return (
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Serial Numbers</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedSerialNumber}
          label="Line Item Status"
          onChange={handleChange}
          MenuProps={MenuProps}
        >
          {serialNumbers.map((num: any) => (
            <MenuItem
              key={num}
              value={num}
            >
              {num}
              </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  const getColumnWidth = () => {
    let width = 130

    rows.forEach((row: InventoryData) => {
        if(row.inventoryType === 1 && rowSelectionModel.includes(row.id)) {
            width = 600
        }
    })
    return width
  }

  const handleRemarks = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: GridRenderCellParams) => {
    let value = e.target.value

    setRows((prev: any) => [...prev].map((row: any) => {
      return params.row.id === row.id ? { ...row, 'remarks': value } : row
    }))
  }

  const getInventoryColumns = () => {
    let minWidth = 100

    let columnToShowCase = rowSelectionModel.length > 0 ? INV_AJUSTMENT_COLUMN : INV_INVENTORY_SHOWCASE

    return columnToShowCase.map(inboundField => {

      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: 'left',
        editable: false
      }

      switch (inboundField.id) {
        case "image":
          row.minWidth = 100;
          row.renderCell = params => {
            let url = params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].img_url : ''
            return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
          }
          break;
        case "name":
          row.minWidth = 550;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.name ? params.row.name : "NA"}>
                <Typography>{params.row.name ? params.row.name : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "inventoryType":
          row.minWidth = 200;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.inventoryType ? InventoryType[params.row.inventoryType] : "NA"}>
                <Typography>{params.row.inventoryType ? InventoryType[params.row.inventoryType] : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "skuId":
          row.minWidth = 200;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.skuId ? params.row.skuId : "NA"}>
                  <Typography>{params.row.skuId ? params.row.skuId : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "currentWeight":
          row.minWidth = 150;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentWeight > 0 ? params.row.currentWeight : 0}>
                <Typography>{params.row.currentWeight > 0 ? params.row.currentWeight : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "currentFineWeight":
          row.minWidth = 150;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}>
                <Typography>{params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "availableStock":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.availableStock ? params.row.availableStock : "NA"
          }
          break;
        case "dimensions":
          row.minWidth = 100;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.dimensions ? params.row.dimensions : "NA"}>
                <Typography>{params.row.dimensions ? params.row.dimensions : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "shape":
          row.minWidth = 100;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.shape ? params.row.shape : "NA"}>
                <Typography>{params.row.shape ? params.row.shape : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "quantity":
          row.minWidth = 120;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.quantity > 0 ? params.row.quantity : 0}>
                <Typography>{params.row.quantity > 0 ? params.row.quantity : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "purity":
          row.minWidth = 100;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.purity ? params.row.purity : "NA"}>
                <Typography>{params.row.purity ? params.row.purity : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "transactionDetails":
          row.minWidth = 150;
          row.renderCell = params => {
            let transactionDetails = params.row.transactionDetails
            return <>{transactionDetails ?
              <Tooltip title='View transaction Details'>
                <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowTranscationDetail(transactionDetails)}><VisibilityIcon /></IconButton>
              </Tooltip> : "NA"
            }</>
          }
          break;
        case "metalType":
          row.minWidth = 100;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.metalType ? params.row.metalType : "NA"}>
                <Typography>{params.row.metalType ? params.row.metalType : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "weight":
          row.minWidth = 180;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentWeight ? params.row.currentWeight : 'NA'}>
                <Typography>{params.row.currentWeight ? params.row.currentWeight : 'NA'}</Typography>
              </Tooltip>
            )
          }
          break;
        case "remarks":
          row.minWidth = 400;
          row.type = 'string';
          row.renderCell = params => {
            return <TextField 
              fullWidth 
              size="small"
              variant="outlined" 
              value={params.row.remarks}
              onChange={(e) => handleRemarks(e, params)} 
              onKeyDown={(e) => e.stopPropagation()}
              type={'string'}
              disabled={!rowSelectionModel.includes(params.row.id)}
            />
          }
          break;
        case "serialNumbers":
          row.minWidth = 200;
          row.renderCell = params => {
            let serialNumbers = JSON.parse(params.row.serialNumbers)
            return <>{
              params.row.inventoryType === 1 && rowSelectionModel.includes(params.row.id)
              ? <SelectSerialNumberBox serialNumbers={serialNumbers} />  
              : serialNumbers ?
               <Tooltip title='View Serial Numbers'>
                <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
               </Tooltip> : "NA"
            }</>
          }
          break;
        default:
          row.minWidth = 100
          break;
      }
      
      return row;
    })
  }

  const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
    if(rows.length > 1 && rows.length === newRowSelectionModel.length) return 
    setRowSelectionModel(newRowSelectionModel);

    let updatedRow: InventoryData[] = []
    if(newRowSelectionModel.length > 0) {

      rows.forEach((row: InventoryData) => {
        if(newRowSelectionModel.includes(row.id)) {
          row['isEditable'] = true
          updatedRow.push(row as InventoryData)
        } else {
          row['isEditable'] = false
          setselectedSerialNumber(null)
          updatedRow.push(row as InventoryData)
        }
      })
    } else {
      rows.forEach((row: InventoryData) => {
        row['isEditable'] = true
        delete row['remarks']
        setselectedSerialNumber(null)
        updatedRow.push(row as InventoryData)
      })
    }
    setRows(updatedRow)
  }

  const handleInventoryAdjustment = async () => {
    const lineItem = rows.find((row: InventoryData) => rowSelectionModel.includes(row.id))

    let payload = {
      lineItem,
      selectedSerialNumber
    }

    let { data, error } = await execute(() => inventoryAdjustment(payload as InventoryAdjustmentParams))

    if(!error) {
      notify('Inventory updated successfully!')
      onClose()
      reloadInventory()
    }
  }

  useEffect(() => {
    let editableRow: InventoryData[] = []

    let updatedRows: InventoryData[] = inventories.data.filter((row: InventoryData) => row.inventoryType === 1 && row.quantity > 0 && (row.purity === 999 || row.purity === 995))
    updatedRows.length > 0 && updatedRows.forEach((row: InventoryData) => {
      row['isEditable'] = true
      delete row['remarks']
      editableRow.push(row as InventoryData)
    })
    setRows(editableRow as InventoryData[])
  },[])

  useEffect(() => {
    reloadInventory()
  }, [])

  let columns = getInventoryColumns()

  return (
    <Container>
      <Table 
        editMode="row"
        rows={rows} 
        getRowId={(row) => row.id} 
        columns={columns} 
        checkboxSelection
        disableRowSelectionOnClick
        isRowSelectable={(params: GridRowParams) => params.row.isEditable}
        onRowSelectionModelChange={handleRowSelectionModel}
        rowSelectionModel={rowSelectionModel}
      />

      <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" variant="contained" onClick={handleInventoryAdjustment} disabled={rowSelectionModel.length <= 0 || !selectedSerialNumber}>Submit</Button>
      </Stack>

      <Modal open={typeof showTranscationDetail != 'boolean'} title={'View Transcation Details'} onClose={closeTranscationDetailModal} maxWidth={'xl'}>
        <ShowTranscationDetails data={showTranscationDetail} />
      </Modal>
      <Modal open={typeof showSerialNumberModal != 'boolean'} title={'view Serial Numbers'} onClose={closeSerialNumberModal} maxWidth={'xl'}>
        <ShowSerialNumbers data={showSerialNumberModal} />
      </Modal>
    </Container>
  )
}

export default InventoryAdjustment